import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ReplayIcon from "@mui/icons-material/Replay";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { MessageContainer } from "./MessageContainer";
import { colors } from "../../../ui/colors";

const tooltipPopperProps = { popper: { sx: { zIndex: "2147483647 !important" } } };

export const PendingMessageBubble = ({ entry, onRetry }) => {
  const isError = entry.status === "error";

  const statusSlot = isError ? (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
      <ErrorOutlineIcon sx={{ fontSize: 13, color: "error.main", verticalAlign: "middle" }} />

      <Tooltip title="Retry" placement="top" slotProps={tooltipPopperProps}>
        <IconButton size="small" onClick={() => onRetry(entry.clientTempId)} sx={{ p: 0.25 }}>
          <ReplayIcon sx={{ fontSize: 12, color: "error.main" }} />
        </IconButton>
      </Tooltip>
    </Box>
  ) : (
    <AccessTimeIcon sx={{ fontSize: 13, color: colors.gray[300], verticalAlign: "middle" }} />
  );

  const bubbleTooltip = isError ? entry.errorMessage || "Message failed to send" : "Sending...";

  return (
    <MessageContainer
      isOwn
      message={{ sender: {}, createdAt: entry.createdAt }}
      senderDisplayName="You"
      statusSlot={statusSlot}
      bubbleTooltip={bubbleTooltip}
    >
      <Typography
        variant="body2"
        sx={{
          color: "inherit",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: "0.95rem",
          lineHeight: 1.6,
        }}
      >
        {entry.kind === "text" ? entry.text : `📎 ${entry.fileName}`}
      </Typography>
    </MessageContainer>
  );
};
